define('bindingHandlers/inlineConfirmation',[
    'jquery',
    'lib/lodash4',
    'lib/knockout',
    'util/externalInclude',
    'extensions/i18n/knockout.i18n'
], function ($,_, ko, include) {
    'use strict';

    //Constants declaration
    var TEMPLATE  = "templates/inlineConfirmation";
    var DEFAULT_OK_KEY = "inline.confirmation.btn.label.ok";
    var DEFAULT_CANCEL_KEY = "inline.confirmation.btn.label.cancel";

    /**
     * Renders template inside element
     * @param node element  - container node
     * @param {Object} data - viewModel Object
     */
    var includeTemplate = function(element, data){
        var templateName = TEMPLATE;
        include.loadTemplate(templateName).then(function () {
            ko.renderTemplate(templateName, data, {afterRender: null}, element, "replaceChildren");
        });
    };

    /**
     * Validates and merges default properties with bindProperties. Returns valid binding properties
     * @param {Object} bindProperties - properties passed in by consumer of api
     * @param {Object} defaultProperties - default properties
     * @returns {Object} valid properties if no errors are thrown due to missing or invalid properties
     */
    var getBindingProperties = function(bindProperties, defaultProperties){
        var errorMessage = "inlineConfirmation binding error. Must specify binding properties: messageKey, show, and onConfirm";

        if (!_.isPlainObject(bindProperties)){
            throw new Error(errorMessage);
        }

        var prop = _.assign(defaultProperties, bindProperties);

        if (!prop.show            ||
            !prop.onConfirm       ||
            !prop.messageKey) {
            throw new Error(errorMessage);
        }
        return prop;
    };

    /**
     * The inlineConfirmation binding will display an inline message with confirmation button with optional additional buttons and an optional cancel button
     * Sample usage
     *  data-bind= "inlineConfirmation:{    messageKey      : 'my.string.key',       // The message key for the string to display as the confirmation message/question that will be displayed to the user.
     *                                      messageData     : myMessageData (Optional)  // The data object used to for replacements in messageKey
     *                                      show            :  myViewModelProperty,  // View model observable property  (boolean) that triggers when the confirmation is shown/hidden
     *                                      customButtons   :  array                 // Array of objects of the form { localizationKey: key, onClick: function }
     *                                      onConfirm       :  myViewModelFunction   // View model function to run when the OK button is clicked
     *                                      confirmLabelKey :  'my.string.key' (Optional)   // Localization key to use for the onConfirm button
     *                                      onCancel        :  myViewModelFunction (Optional)   // View model function to run when the Cancel button is clicked
     *                                      cancelLabelKey :  'my.string.key' (Optional)   // Localization key to use for the onCancel button
     *                                      isWaiting       :  actionInProgress      // View model observable property -  Boolean. When true the spinner will show on the button for asynchronous actions
     *  }"
     */

    ko.bindingHandlers.inlineConfirmation = {
        init: function (element, valueAccessor) {
            var bindProperties      = ko.unwrap(valueAccessor());
            var defaultProperties   = {
                isWaiting: ko.observable(false)
            };

            var properties = getBindingProperties(bindProperties, defaultProperties);

            _.forEach(properties.customButtons, function (customButton) {
                customButton.isWaiting = customButton.isWaiting || ko.observable(false);
            });

            var confirmationViewModel = {
                'customButtons'  :   properties.customButtons,
                'onOkClick'      :   properties.onConfirm,
                'confirmLabelKey':   properties.confirmLabelKey || DEFAULT_OK_KEY,
                'onCancelClick'  :   function(){
                                         if (properties.onCancel) {
                                             properties.onCancel();
                                         }
                                         properties.show(false);
                                     },
                'cancelLabelKey' :   properties.cancelLabelKey || DEFAULT_CANCEL_KEY,
                'messageKey'     :   properties.messageKey,
                'messageData'    :   properties.messageData,
                'isWaiting'      :   properties.isWaiting
            };

            includeTemplate(element, confirmationViewModel, null);
        }
    };
});

